import React from 'react';
import PlansContent from './PlansContent';
import { CloseOutlined } from '../icons';
import './PlansModal.css';

// Tela de vendas contextual: cada ponto de bloqueio do plano free (simulado,
// questões livres, diário de estudos, diário de treinos) abre este modal com
// sua própria copy/trackingPrefix, reaproveitando a mesma grade de planos da
// página /planos (PlansContent) em vez de uma oferta única separada.
function PlansModal({ heroTitle, heroSubtitle, trackingPrefix, onClose }) {
  return (
    <div className="plans-modal-backdrop">
      <div className="plans-modal-card">
        <button type="button" className="plans-modal-close" onClick={onClose} aria-label="Fechar">
          <CloseOutlined style={{ fontSize: 20 }} />
        </button>
        <PlansContent heroTitle={heroTitle} heroSubtitle={heroSubtitle} trackingPrefix={trackingPrefix} />
      </div>
    </div>
  );
}

export default PlansModal;
